import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina M.',
    location: 'Buenos Aires',
    text: 'Mi hijo dormía súper mal y ahora hace las rutinas todas las noches. Es increíble el cambio en tan poco tiempo.',
    color: 'bg-pastel-lavender'
  }, {
    name: 'Mariana P.',
    location: 'Córdoba',
    text: 'Pensé que no le iba a gustar, pero ahora me pide hacer yoga juntos. Se volvió nuestro momento favorito del día.',
    color: 'bg-pastel-aqua'
  }, {
    name: 'Sofía R.',
    location: 'Rosario',
    text: 'Bajó muchísimo la ansiedad de mi hija de 6 años. Las cartas de posturas son hermosas y súper prácticas.',
    color: 'bg-pastel-pink'
  }];
  return <section className="py-20 bg-white" data-id="element-282">
      <div className="container mx-auto px-5 sm:px-8 lg:px-12" data-id="element-283">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-284">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4" data-id="element-285">
            Mamás que ya transformaron sus rutinas
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-286">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-card rounded-3xl p-8 relative" data-id="element-287">
              <div className="flex gap-1 text-pastel-yellow mb-4" data-id="element-288">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={18} fill="currentColor" data-id="element-289" />)}
              </div>

              <p className="text-gray-700 text-lg mb-6 italic" data-id="element-290">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-291">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg ${testimonial.color}`} data-id="element-292">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-293">
                  <div className="font-bold text-gray-900" data-id="element-294">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-295">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}